import { useQuery } from 'react-query';

import { FEATURES } from '../../constants/endpoints';
import api from '../../utils/api';

const fetchFreeTrialPeriod = () => api.get(`${FEATURES}/trial-period`);
export const useFetchFreeTrialPeriod = () =>
  useQuery([FEATURES], async () => {
    const data = await fetchFreeTrialPeriod();
    const freeTrialPeriod = parseInt(data?.trialPeriodDays);

    return isNaN(freeTrialPeriod) ? 7 : freeTrialPeriod;
  });



// WEBPACK FOOTER //
// ./src/hooks/react-query/useFeatureData.js